export default __webpack_public_path__ + "static/media/spinner.7738ab91.svg";